import create from "zustand";

//** Recurso Authenticate */
const rutaStore = create((set:any, get:any) => ({

  rutaArray:[],
  opcRuta:"",
  objError: { hasError: false, 
              function:"",
              desError:"" }, 

    generaObjError: async (h:any, f:any, d:any) => {
    //alert('rutaStore - generaObjError:' + h + f + d);
    //console.log('*generaObjError (entra): h: ', h , ' f: ', f , ' d: ', d );
    let paso = { hasError: h, function:f, desError:d}
    set( { objError: paso } );
    console.log('rutaStore - generaObjError (sale) - objError: ', get().objError);
    },
  
    setGeneraRuta: async (ruta:any) => {
      //alert('setGeneraRuta'  + ruta);
      try{
        set({opcRuta:ruta});
        let ra= get().rutaArray;
        if (ra.length===0){
            ra.push({"ruta":ruta});
        }
        else{
            let idx=ra.findIndex((r:any)=>r.ruta===ruta);
            if (idx>-1){//ya hay una ruta existente
                ra.splice(idx+1);
            }
            else{//Aún no está la ruta
                ra.push({"ruta":ruta});
            }
        }
         set({rutaArray:ra});   
  
      } catch (error){
 
      } finally{
          set({ isLoading:false });
      };
     console.log('opcRuta: ', get().opcRuta);
     console.log('rutaArray: ', get().rutaArray);



    },  

  
}));

export default rutaStore;

